import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IRacingLicenseGradeListData } from "../../_common/interface/racingLicenseGrade/iRacingLicenseGradeListData";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { toastr } from "../../_components/toastr/toastr";
import { splitWordOnCamelCase } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { racingLicenseGradeService } from "../../_services/racingLicenseGrade.service";
import { useContainerStyles } from "../../_styles/container.styles";
import { RacingLicenseManageDrawer } from "./racingLicenseGrade-manage";


export function RacingLicenseIndex() {

    const [data, setData] = useState<IRacingLicenseGradeListData>({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'price',
                header: 'Price',
            },
            {
                accessorKey: 'durationValidityName',
                header: 'Duration Validity',
                accessorFn: (rowData: any) => <>{splitWordOnCamelCase(rowData.durationValidityName)}</>,
            },
            {
                accessorKey: 'racingLicenseTypeName',
                header: 'Type',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return racingLicenseGradeService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }
    function onDelete(id: number) {
        setLoading(true);
        return racingLicenseGradeService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success(" Motorsport Licence Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };


    return (
        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Motorsport Licences"
                    buttonName="Motorsport Licence"
                    onClick={() => setSelectedId(0)}
                    actionType="create"
                />

                <Paper>

                    <ValidatorForm onSubmit={fetchData}>

                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>

                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        onEdit={setSelectedId}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />

                    <RacingLicenseManageDrawer
                        isOpen={selectedId != null}
                        itemId={selectedId}
                        onSave={() => { setSelectedId(null); fetchData(); }}
                        onClose={() => { setSelectedId(null); fetchData(); }}
                    />

                </Paper>

            </div>
        </>

    );

}
